import { useContext, useState } from "react"
import { FiscalContext } from "../../../context/FiscalContext"
import { api } from "../../../api/api"
import { Toast } from "../../../utils/Toast"
import { useSWRConfig } from "swr"

export function ModalFiscalCancel() {
  const { idOrder, setIdOrder } = useContext(FiscalContext)
  const { mutate } = useSWRConfig()
  const [messageRefused, setMessageRefused] = useState('')

  async function cancelDoc() {
    if (!idOrder) {
      return Toast.warning('Selecione a nota por favor')
    }

    if (!messageRefused || messageRefused.length < 15 || messageRefused.length > 255) {
      return Toast.warning('O motivo deve conter de 15 a 255 caracteres.')
    }

    await api.post('/nfce/cancel', { idOrder: idOrder, messageRefused })
    
    await mutate(['/nfce', {
      startDate: '',
      endDate: ''
    }])

    document.getElementById('modalFiscalCancel').click()
    Toast.success('Nota cancelada com sucesso')
  }

  return (
    <div className="modal fade admin-form-modal" id="fiscalCancel" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="fiscalCancelLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="fiscalCancelLabel">Cancelar documento fiscal</h5>
            <button type="button" id="modalFiscalCancel" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
              setIdOrder(null)
              setMessageRefused('')
            }}></button>
          </div>
          <div className="modal-body">
            <div>
              <div>
                <label htmlFor="motivationCancel">Motivo do cancelamento</label>
                <textarea value={messageRefused} onChange={(e) => setMessageRefused(e.target.value)} maxLength={255} rows={3} id="motivationCancel" />
                <div className="form-text">Deve conter de 15 a 255 caracteres. {messageRefused.length}/255</div>
              </div>
              <div className="mt-3 text-end">
                <button className="admin-primary-button" onClick={() => cancelDoc()}>Confirmar cancelamento</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
